import { Injectable, inject } from '@angular/core';
import { ASSET_REPOSITORY } from '../ports';
import { ExplorerStore } from '../state/explorer.store';

@Injectable()
export class LoadAssetsUseCase {
  private readonly repository = inject(ASSET_REPOSITORY);
  private readonly store = inject(ExplorerStore);
  private _inFlight = false;

  async execute(): Promise<void> {
    if (this.store.isAssetsLoaded() || this._inFlight) return;

    this._inFlight = true;
    try {
      this.store.setAssetsLoading(true);
      this.store.setAssetsError(null);

      const assets = await this.repository.loadAll();
      this.store.loadAssets(assets);
    } catch (error) {
      const message =
        error instanceof Error ? error.message : 'Failed to load assets';
      this.store.setAssetsError(message);
    } finally {
      this._inFlight = false;
      this.store.setAssetsLoading(false);
    }
  }
}
